import { StageDef } from '../automationMachineInterfaces'
import { STRAVA_AUTOMATION_STAGE_STATUSES } from './stravaAutomationStageStatuses'
import {
  getCurrentValueForStravaCheckbox,
  saveCurrentValueForStravaCheckbox,
  toggleStravaCheckbox,
} from './stravaCheckboxUtils'
import * as stravaUrls from './stravaUrls'
import { StravaSettingKey } from '../../recommendations/recommendationSettingsKeys'
import * as enums from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

// Settings properties
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) =>
    value ? 'Not sending notifications' : 'Sending notifications',
  )

const getIsFulfilledFn = (key) => getIsFulfilledFnFromKey(key, (value) => value)

const getCantUndoFn = () => defaultCantUndoFn

const getIsDisabledFn = () => defaultIsDisabledFn

const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

// Setup gather stage definitions

const NOTIFICATION_SETTINGS = {
  [StravaSettingKey.FOLLOWER_NOTIFICATIONS]: 'Do not send these notifications',
}

enum StageKey {
  GATHER_SETTING_NOTIFICATIONS = 'GATHER_SETTING_NOTIFICATIONS',
  UPDATE_SETTING_NOTIFICATIONS = 'UPDATE_SETTING_NOTIFICATIONS',
  UNDO_SETTING_NOTIFICATIONS = 'UNDO_SETTING_NOTIFICATIONS',
}

const gatherStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.GATHER_SETTING_NOTIFICATIONS,
    status: STRAVA_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: stravaUrls.privacySettingsUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext
      saveCurrentValueForStravaCheckbox(
        updateStoredInitialValues,
        NOTIFICATION_SETTINGS,
        StravaSettingKey.FOLLOWER_NOTIFICATIONS,
        enums.StravaRecommendationKey.STRAVA_NOTIFICATIONS,
      )
    },
  },
]

const updateStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.UPDATE_SETTING_NOTIFICATIONS,
    status: STRAVA_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: stravaUrls.privacySettingsUrl,
    action: async (machineContext, userContext) => {
      const { isDry } = userContext

      const currentSetting = await getCurrentValueForStravaCheckbox(
        NOTIFICATION_SETTINGS[StravaSettingKey.FOLLOWER_NOTIFICATIONS],
      )

      if (!currentSetting && !isDry) {
        return toggleStravaCheckbox(
          NOTIFICATION_SETTINGS[StravaSettingKey.FOLLOWER_NOTIFICATIONS],
        )
      }
      return null
    },
  },
]

const undoStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.UNDO_SETTING_NOTIFICATIONS,
    status: STRAVA_AUTOMATION_STAGE_STATUSES.UNDOING_SETTINGS,
    url: stravaUrls.privacySettingsUrl,
    action: async (machineContext, userContext) => {
      const { isDry, initialValues } = userContext

      if (
        !initialValues ||
        initialValues[StravaSettingKey.FOLLOWER_NOTIFICATIONS] === undefined ||
        initialValues[StravaSettingKey.FOLLOWER_NOTIFICATIONS] === null
      ) {
        return null
      }

      const currentSetting = getCurrentValueForStravaCheckbox(
        NOTIFICATION_SETTINGS[StravaSettingKey.FOLLOWER_NOTIFICATIONS],
      )

      if (
        currentSetting !==
          initialValues[StravaSettingKey.FOLLOWER_NOTIFICATIONS] &&
        !isDry
      ) {
        return toggleStravaCheckbox(
          NOTIFICATION_SETTINGS[StravaSettingKey.FOLLOWER_NOTIFICATIONS],
        )
      }
      return null
    },
  },
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
